import React from 'react';
import Grid from '../../../components/Grid';
import Icon from '../../../components/Icon';
import './styles.css';
import PropTypes from 'prop-types';
import { getDollarFormattedText } from '../../../utils/strings';
import { AWARD_RANGE, AWARD_FULL_TUITION } from '../../../utils/scholarships';

const getAmount = (scholarship) => {
  if (scholarship.awardType === AWARD_FULL_TUITION) return 'Full Tuition';
  const rangeSuffix =
    scholarship.awardType === AWARD_RANGE
      ? ` - ${getDollarFormattedText(scholarship.awAmountMax)}`
      : '';
  return `$${getDollarFormattedText(scholarship.awAmountMin)}${rangeSuffix}`;
};

const getClassRank = (scholarship) => {
  if (scholarship.classRankMax === null) return '-';
  /* istanbul ignore next */
  const rangeSuffix =
    scholarship.classRankMin !== null ? ` - ${scholarship.classRankMin}` : '';
  return `Top ${scholarship.classRankMax}${rangeSuffix}%`;
};

const getGPADisplayValues = (min, max) => {
  if (min === null) return '-';
  const convMin = `${min}`.includes('.') ? `${min}` : `${min}.0`;
  const convMax = `${max}`.includes('.') ? `${max}` : `${max}.0`;
  return max !== null ? `${convMin} - ${convMax}` : `${convMin}+`;
};

const displayValues = (min, max) => {
  if (min === null) return '-';
  return max !== null ? `${min} - ${max}` : `${min}+`;
};

const getClassNameForRow = (scholarship, bestMatch, index, lastRowIndex) => {
  const lastRow = index === lastRowIndex ? ' last-row' : '';
  const bestMatchClass = scholarship === bestMatch ? ' best-match' : '';
  return `financial-aid-scholarships-grid-row${lastRow}${bestMatchClass}`;
};

function ScholarshipRow({
  scholarship,
  bestMatch,
  index,
  lastRowIndex,
  displayGpaColumn,
  displaySatColumn,
  displayActColumn,
  displayClassRankColumn,
  displayAmountColumn,
}) {
  return (
    <React.Fragment>
      <Grid.Row
        className={getClassNameForRow(scholarship, bestMatch, index, lastRowIndex)}
      >
        <Grid.Column
          textAlign="right"
          className="financial-aid-scholarships-grid-heading-column scholarship-name"
          data-cy="financial-aid-scholarships-scholarship-name"
        >
          {scholarship === bestMatch && (
            <Icon name="user circle" className="best-match-user-icon" />
          )}
          {scholarship.name}
        </Grid.Column>
        {displayAmountColumn && (
          <Grid.Column
            textAlign="center"
            className="financial-aid-scholarships-grid-heading-column scholarships-amount-column"
            data-cy="financial-aid-scholarships-amount"
          >
            {getAmount(scholarship)}
          </Grid.Column>
        )}
        {displayGpaColumn && (
          <Grid.Column
            textAlign="center"
            className="financial-aid-scholarships-grid-heading-column"
            data-cy="financial-aid-scholarships-gpa"
          >
            {getGPADisplayValues(scholarship.gpaMin, scholarship.gpaMax)}
          </Grid.Column>
        )}
        {displaySatColumn && (
          <Grid.Column
            textAlign="center"
            className="financial-aid-scholarships-grid-heading-column"
            data-cy="financial-aid-scholarships-sat"
          >
            {displayValues(scholarship.satMin, scholarship.satMax)}
          </Grid.Column>
        )}
        {displayActColumn && (
          <Grid.Column
            textAlign="center"
            className="financial-aid-scholarships-grid-heading-column"
            data-cy="financial-aid-scholarships-act"
          >
            {displayValues(scholarship.actMin, scholarship.actMax)}
          </Grid.Column>
        )}
        {displayClassRankColumn && (
          <Grid.Column
            textAlign="center"
            className="financial-aid-scholarships-grid-heading-column"
            data-cy="financial-aid-scholarships-class-rank"
          >
            {getClassRank(scholarship)}
          </Grid.Column>
        )}
      </Grid.Row>
    </React.Fragment>
  );
}

ScholarshipRow.propTypes = {
  scholarship: PropTypes.object,
  bestMatch: PropTypes.object,
  index: PropTypes.number,
  lastRowIndex: PropTypes.number,
  displayGpaColumn: PropTypes.bool,
  displaySatColumn: PropTypes.bool,
  displayActColumn: PropTypes.bool,
  displayClassRankColumn: PropTypes.bool,
};

export default ScholarshipRow;
